import React, { FC } from "react";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import rehypeExternalLinks from "rehype-external-links";

interface Props {
  content: string;
}

const Markdown: FC<Props> = ({ content }) => {
  return (
    <ReactMarkdown
      children={content}
      remarkPlugins={[remarkBreaks]}
      rehypePlugins={[
        [
          rehypeExternalLinks,
          {
            target: "_blank",
          },
        ],
      ]}
    />
  );
};

export default Markdown;
